package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ButtonDefaults
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.PainelFixo
import br.com.htms.inspeccaocampo.ui.kit.Ordenacao
import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.HorizontalScrollbar
import androidx.compose.foundation.ScrollbarStyle
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollbarAdapter
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.Acessos
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.AuthUserListItem
import br.com.htms.inspeccaocampo.auth.ProfileTypes
import br.com.htms.inspeccaocampo.data.TagConfig
import br.com.htms.inspeccaocampo.data.ativos.AtivosApi
import br.com.htms.inspeccaocampo.data.ativos.AtivosEscopo
import br.com.htms.inspeccaocampo.data.ativos.CentroCusto
import br.com.htms.inspeccaocampo.data.JsonMap
import androidx.compose.ui.window.PopupProperties
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.launch

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedAdminUsersPanel(
    isMaster: Boolean,
    tags: List<TagConfig>,
    onMessage: (String) -> Unit
) {
    val catalogo = tags.ifEmpty { TagConfig.padrao() }
    fun rotuloTag(id: String): String =
        catalogo.find { it.id.equals(id, ignoreCase = true) }?.rotulo?.trim()?.ifBlank { null } ?: ProfileTypes.rotulo(id)
    fun labelTags(types: Collection<String>): String {
        val n = ProfileTypes.normalize(types)
        return if (n.isEmpty()) "—" else n.joinToString(" + ") { rotuloTag(it) }
    }
    fun opcoesTag(selecionadas: Set<String>): List<TagConfig> {
        val ids = catalogo.map { it.id.uppercase() }.toSet()
        val extras = ProfileTypes.normalize(selecionadas).filter { it !in ids }.map { TagConfig(it, it) }
        return catalogo + extras
    }
    var users by remember { mutableStateOf<List<AuthUserListItem>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    var novoUser by remember { mutableStateOf("") }
    var novoNome by remember { mutableStateOf("") }
    var novaSenha by remember { mutableStateOf("") }
    var novoRole by remember { mutableStateOf("user") }
    var novoTags by remember { mutableStateOf(setOf(ProfileTypes.TST)) }
    var novoAcessos by remember { mutableStateOf(Acessos.padraoDasTags(listOf(ProfileTypes.TST)).toSet()) }
    /** Enquanto o Master não mexer nos acessos, eles acompanham o padrão da TAG escolhida. */
    var novoAcessosAjustados by remember { mutableStateOf(false) }
    var roleMenu by remember { mutableStateOf(false) }
    var editingId by remember { mutableStateOf<String?>(null) }
    var buscaUsuario by remember { mutableStateOf("") }
    var confirmarRemocao by remember { mutableStateOf<AuthUserListItem?>(null) }
    var editNome by remember { mutableStateOf("") }
    var editTags by remember { mutableStateOf(emptySet<String>()) }
    var editAcessos by remember { mutableStateOf(emptySet<String>()) }
    var editRole by remember { mutableStateOf("user") }
    var editAbas by remember { mutableStateOf(AtivosEscopo.modosDe(null)) }
    var editLimitarCentros by remember { mutableStateOf(false) }
    var editCentros by remember { mutableStateOf(emptySet<String>()) }
    var centrosAtivos by remember { mutableStateOf<List<CentroCusto>>(emptyList()) }
    var editRoleMenu by remember { mutableStateOf(false) }
    var editSenha by remember { mutableStateOf("") }
    var salvandoEdicao by remember { mutableStateOf(false) }
    var erroEdicao by remember { mutableStateOf<String?>(null) }
    var avisoSalvo by remember { mutableStateOf<String?>(null) }
    var listaUsuariosVisivel by remember { mutableStateOf(false) }
    var matrizVisivel by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    LaunchedEffect(isMaster) {
        if (!isMaster) return@LaunchedEffect
        AtivosApi.dados().onSuccess { centrosAtivos = it?.centrosCusto.orEmpty().sortedBy { c -> c.codigo } }
    }

    var colaboradores by remember { mutableStateOf<List<String>>(emptyList()) }
    var nomeMenu by remember { mutableStateOf(false) }
    val sugestoesNome = remember(novoNome, colaboradores) {
        val q = novoNome.trim()
        if (q.length < 2) emptyList()
        else colaboradores
            .filter { it.contains(q, ignoreCase = true) && !it.equals(q, ignoreCase = true) }
            .take(8)
    }

    fun senhaForte(senha: String): Boolean {
        if (senha.length < 8) return false
        if (!senha.any { it.isLetter() }) return false
        if (!senha.any { it.isDigit() }) return false
        return true
    }

    fun recarregar() {
        scope.launch {
            loading = true
            AuthApi.listUsers()
                .onSuccess {
                    // Master `admin` já vem oculto da API; reforço no client.
                    users = it.filter { u -> !u.username.equals("admin", ignoreCase = true) }
                }
                .onFailure { onMessage(it.message ?: "Falha ao listar usuários") }
            loading = false
        }
    }

    LaunchedEffect(Unit) { recarregar() }
    LaunchedEffect(Unit) {
        AuthApi.apiJson("GET", "/users/colaboradores").onSuccess { text ->
            colaboradores = runCatching {
                JsonMap.parse(text).array("colaboradores").orEmpty()
                    .mapNotNull { (it as? JsonMap)?.str("nome")?.trim()?.takeIf { n -> n.isNotEmpty() } }
                    .distinct()
            }.getOrDefault(emptyList())
        }
    }

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            TituloSecao("Administração de usuários")
            Text(
                if (isMaster) {
                    "TAG = função do usuário em campo. A lista é a de Configurações → TAGs. " +
                        "Acessos = formulários e módulos que ele pode abrir; só o Master altera."
                } else {
                    "Você pode adicionar, editar e remover usuários comuns (não admins). " +
                        "TAG, acessos e role Admin só o Master altera."
                },
                style = MaterialTheme.typography.bodySmall
            )

            AppOutlinedTextField(
                value = novoUser,
                onValueChange = { novoUser = it },
                label = { Text("Novo usuário (login)") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            ExposedDropdownMenuBox(
                expanded = nomeMenu && sugestoesNome.isNotEmpty(),
                onExpandedChange = { nomeMenu = it }
            ) {
                AppOutlinedTextField(
                    value = novoNome,
                    onValueChange = {
                        novoNome = it
                        nomeMenu = true
                    },
                    label = { Text("Nome completo") },
                    placeholder = { Text("Digite para buscar nos colaboradores") },
                    singleLine = true,
                    modifier = Modifier
                        .fillMaxWidth()
                        .menuAnchor(),
                    colors = FormFieldDefaults.textFieldColors()
                )
                // Popup não focável: senão o menu rouba o teclado e o campo para de aceitar digitação.
                androidx.compose.material3.DropdownMenu(
                    expanded = nomeMenu && sugestoesNome.isNotEmpty(),
                    onDismissRequest = { nomeMenu = false },
                    properties = PopupProperties(focusable = false),
                    modifier = Modifier.exposedDropdownSize()
                ) {
                    sugestoesNome.forEach { nome ->
                        DropdownMenuItem(
                            text = { Text(nome) },
                            onClick = {
                                novoNome = nome
                                nomeMenu = false
                            }
                        )
                    }
                }
            }
            AppOutlinedTextField(
                value = novaSenha,
                onValueChange = { novaSenha = it },
                label = { Text("Senha (mín. 8, letra e número)") },
                singleLine = true,
                visualTransformation = PasswordVisualTransformation(),
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            if (isMaster) {
                br.com.htms.inspeccaocampo.ui.kit.Seletor(
                    "Role do sistema",
                    listOf("user" to "Usuário", "admin" to "Admin (sistema)"),
                    if (novoRole == "admin") "admin" else "user",
                    { novoRole = it }
                )
                TagsEditor(
                    opcoes = opcoesTag(novoTags),
                    rotuloDe = ::rotuloTag,
                    tags = novoTags,
                    onChange = { tags ->
                        novoTags = tags
                        if (!novoAcessosAjustados) novoAcessos = Acessos.padraoDasTags(tags).toSet()
                    }
                )
                AcessosEditor(
                    acessos = novoAcessos,
                    tags = novoTags,
                    adminRole = novoRole == "admin",
                    onChange = { acessos, ajustado ->
                        novoAcessos = acessos
                        novoAcessosAjustados = ajustado
                    }
                )
                if (!novoAcessosAjustados) {
                    Text(
                        "Acessos pré-marcados pelo padrão da TAG. Ajuste se precisar.",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            } else {
                Text(
                    "Novo usuário será criado como Usuário comum com TAG TST e os acessos padrão dela " +
                        "(o Master pode ajustar depois).",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
            PortalButton(
                onClick = {
                    val role = if (isMaster) novoRole else "user"
                    val types = if (isMaster) ProfileTypes.normalize(novoTags) else listOf(ProfileTypes.TST)
                    if (types.isEmpty()) {
                        onMessage("Selecione ao menos uma TAG")
                        return@PortalButton
                    }
                    if (!senhaForte(novaSenha)) {
                        onMessage("Senha: mín. 8 caracteres, com letra e número")
                        return@PortalButton
                    }
                    scope.launch {
                        AuthApi.createUser(
                            novoUser.trim(),
                            novaSenha,
                            role,
                            types,
                            nome = novoNome.trim().ifBlank { null },
                            acessos = if (isMaster) Acessos.normalizar(novoAcessos) else null
                        )
                            .onSuccess {
                                onMessage("Usuário ${it.username} criado.")
                                novoUser = ""
                                novoNome = ""
                                novaSenha = ""
                                novoRole = "user"
                                novoTags = setOf(ProfileTypes.TST)
                                novoAcessos = Acessos.padraoDasTags(listOf(ProfileTypes.TST)).toSet()
                                novoAcessosAjustados = false
                                recarregar()
                            }
                            .onFailure { onMessage(it.message ?: "Falha ao criar") }
                    }
                },
                modifier = Modifier.fillMaxWidth(),
                enabled = novoUser.isNotBlank() &&
                    senhaForte(novaSenha) &&
                    (!isMaster || novoTags.isNotEmpty())
            ) {
                Text("Adicionar usuário")
            }

            fun alternarEdicao(u: AuthUserListItem) {
                erroEdicao = null
                if (editingId == u.id) {
                    editingId = null
                    editSenha = ""
                    editNome = ""
                } else {
                    editingId = u.id
                    editSenha = ""
                    editNome = u.nome.orEmpty()
                    editTags = ProfileTypes.normalize(u.profileTypes).toSet()
                    editAcessos = Acessos.normalizar(u.acessos).toSet()
                    editRole = if (u.role.equals("admin", true)) "admin" else "user"
                    editAbas = AtivosEscopo.modosDe(u.ativosAbas)
                    editLimitarCentros = u.ativosCentros != null
                    editCentros = u.ativosCentros.orEmpty().split(',').map { it.trim() }.filter { it.isNotEmpty() }.toSet()
                }
            }
            confirmarRemocao?.let { alvo ->
                AlertDialog(
                    onDismissRequest = { confirmarRemocao = null },
                    title = { Text("Remover usuário?") },
                    text = { Text("${alvo.nome?.takeIf { it.isNotBlank() } ?: alvo.username} (${alvo.username}) perderá o acesso ao portal.") },
                    confirmButton = {
                        TextButton(
                            onClick = {
                                confirmarRemocao = null
                                scope.launch {
                                    AuthApi.deleteUser(alvo.id)
                                        .onSuccess {
                                            onMessage("Removido: ${alvo.username}")
                                            if (editingId == alvo.id) editingId = null
                                            recarregar()
                                        }
                                        .onFailure {
                                            onMessage(it.message ?: "Falha ao remover. Verifique a conexão.")
                                        }
                                }
                            },
                            colors = ButtonDefaults.textButtonColors(contentColor = PortalCores.Vermelho)
                        ) { Text("Remover") }
                    },
                    dismissButton = { TextButton(onClick = { confirmarRemocao = null }) { Text("Cancelar") } }
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    if (loading) "Carregando..." else "Usuários (${users.size})",
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier.weight(1f)
                )
                if (isMaster) {
                    TextButton(
                        onClick = { matrizVisivel = !matrizVisivel },
                        enabled = !loading
                    ) {
                        Text(if (matrizVisivel) "Fechar matriz" else "Matriz de acessos")
                    }
                }
                TextButton(
                    onClick = { listaUsuariosVisivel = !listaUsuariosVisivel },
                    enabled = !loading
                ) {
                    Text(if (listaUsuariosVisivel) "Ocultar" else "Mostrar")
                }
            }
            avisoSalvo?.let { msg ->
                Row(
                    Modifier.fillMaxWidth()
                        .background(PortalCores.Verde.copy(alpha = 0.10f), RoundedCornerShape(10.dp))
                        .padding(start = 14.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(msg, color = PortalCores.Verde, fontWeight = FontWeight.SemiBold, modifier = Modifier.weight(1f))
                    TextButton(onClick = { avisoSalvo = null }) { Text("OK") }
                }
            }
            if (isMaster && matrizVisivel) {
                MatrizAcessos(
                    users = users,
                    centros = centrosAtivos,
                    tags = catalogo,
                    rotuloDe = ::rotuloTag,
                    onMessage = onMessage,
                    onSalvo = { recarregar() }
                )
            }
            if (listaUsuariosVisivel) {
            PainelFixo {
                CampoBusca(buscaUsuario, { buscaUsuario = it }, "Buscar por nome, login ou TAG", Modifier.fillMaxWidth())
            }
            val q = buscaUsuario.trim()
            val filtrados = users.filter { u ->
                q.isEmpty() || u.username.contains(q, true) || u.nome.orEmpty().contains(q, true) ||
                    labelTags(u.profileTypes).contains(q, true)
            }.sortedBy { (it.nome?.takeIf { n -> n.isNotBlank() } ?: it.username).lowercase() }
            val grupos = listOf(
                "Administradores" to filtrados.filter { it.role.equals("admin", true) },
                "Usuários" to filtrados.filterNot { it.role.equals("admin", true) }
            ).filter { it.second.isNotEmpty() }
            if (filtrados.isEmpty()) {
                Text("Nenhum usuário encontrado.", color = PortalCores.CinzaTexto)
            }
            grupos.forEach { (grupo, lista) ->
            Text(
                "$grupo (${lista.size})",
                style = MaterialTheme.typography.labelLarge,
                fontWeight = FontWeight.Bold,
                color = PortalCores.Navy,
                modifier = Modifier.padding(top = 8.dp)
            )
            lista.forEach { u ->
                val aberto = editingId == u.id
                Card(
                    colors = CardDefaults.cardColors(containerColor = if (aberto) PortalCores.AzulClaro else PortalCores.Cartao),
                    border = if (aberto) BorderStroke(1.dp, PortalCores.AzulIcone) else PortalCores.BordaCartao,
                    modifier = Modifier.fillMaxWidth()
                ) {
                Column(
                    modifier = Modifier.fillMaxWidth().padding(12.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(8.dp)).clickable { alternarEdicao(u) },
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier.size(38.dp).clip(CircleShape)
                                .background(if (aberto) PortalCores.Marca else PortalCores.AzulClaro),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                iniciais(u.nome?.takeIf { it.isNotBlank() } ?: u.username),
                                color = if (aberto) Color.White else PortalCores.Navy,
                                fontWeight = FontWeight.Bold,
                                style = MaterialTheme.typography.labelLarge
                            )
                        }
                        Spacer(Modifier.width(12.dp))
                        Column(modifier = Modifier.weight(1f)) {
                            Text(
                                u.nome?.takeIf { it.isNotBlank() } ?: u.username,
                                fontWeight = FontWeight.Bold,
                                color = PortalCores.TextoForte
                            )
                            Text(
                                buildString {
                                    append(u.username)
                                    append(" · ")
                                    append(if (u.role.equals("admin", true)) "Admin" else "Usuário")
                                    append(" · TAG ")
                                    append(labelTags(u.profileTypes))
                                },
                                style = MaterialTheme.typography.bodySmall,
                                color = PortalCores.CinzaTexto
                            )
                            Text(
                                "Acessos: " + Acessos.normalizar(u.acessos)
                                    .joinToString(", ") { Acessos.rotuloCurto(it) }
                                    .ifEmpty { "nenhum" },
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                        TextButton(onClick = { alternarEdicao(u) }) {
                            Text(if (aberto) "Fechar" else "Editar")
                        }
                        TextButton(
                            onClick = { confirmarRemocao = u },
                            colors = ButtonDefaults.textButtonColors(contentColor = PortalCores.Vermelho)
                        ) { Text("Remover") }
                    }
                    if (editingId == u.id) {
                        AppOutlinedTextField(
                            value = editNome,
                            onValueChange = { editNome = it },
                            label = { Text("Nome completo") },
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        if (isMaster) {
                            br.com.htms.inspeccaocampo.ui.kit.Seletor(
                                "Role do sistema",
                                listOf("user" to "Usuário", "admin" to "Admin (sistema)"),
                                editRole,
                                { editRole = it }
                            )
                            TagsEditor(
                                opcoes = opcoesTag(editTags),
                                rotuloDe = ::rotuloTag,
                                tags = editTags,
                                onChange = { editTags = it }
                            )
                            AcessosEditor(
                                acessos = editAcessos,
                                tags = editTags,
                                adminRole = editRole == "admin",
                                onChange = { acessos, _ ->
                                    val ligou = Acessos.ATIVOS_EDITAR in acessos && Acessos.ATIVOS_EDITAR !in editAcessos
                                    val desligou = Acessos.ATIVOS_EDITAR !in acessos && Acessos.ATIVOS_EDITAR in editAcessos
                                    editAcessos = acessos
                                    if (ligou || desligou) {
                                        val modo = if (ligou) "E" else "V"
                                        editAbas = AtivosEscopo.abas.associate { it.first to modo }
                                    }
                                }
                            )
                            if (editRole != "admin" && Acessos.ATIVOS in editAcessos) {
                                EscopoAtivosEditor(
                                    abas = editAbas,
                                    onAbas = { editAbas = it },
                                    limitar = editLimitarCentros,
                                    onLimitar = { ligado ->
                                        editLimitarCentros = ligado
                                        if (ligado && editCentros.isEmpty()) {
                                            editCentros = centrosAtivos.filter {
                                                it.admUsername.equals(u.username, true) || it.engenheiroUsername.equals(u.username, true)
                                            }.map { it.id }.toSet()
                                        }
                                    },
                                    centrosSel = editCentros,
                                    onCentros = { editCentros = it },
                                    centros = centrosAtivos
                                )
                            }
                        }
                        AppOutlinedTextField(
                            value = editSenha,
                            onValueChange = { editSenha = it },
                            label = { Text("Nova senha (opcional — mín. 8, letra e número)") },
                            singleLine = true,
                            visualTransformation = PasswordVisualTransformation(),
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        erroEdicao?.let {
                            Text(it, color = PortalCores.Vermelho, fontWeight = FontWeight.SemiBold)
                        }
                        PortalButton(
                            onClick = {
                                if (salvandoEdicao) return@PortalButton
                                erroEdicao = null
                                if (isMaster && editTags.isEmpty()) {
                                    erroEdicao = "Selecione ao menos uma TAG."
                                    return@PortalButton
                                }
                                if (editSenha.isNotBlank() && !senhaForte(editSenha)) {
                                    erroEdicao = "Senha: mín. 8 caracteres, com letra e número."
                                    return@PortalButton
                                }
                                if (!isMaster && editSenha.isBlank() && editNome.trim() == u.nome.orEmpty()) {
                                    erroEdicao = "Altere o nome ou informe a nova senha."
                                    return@PortalButton
                                }
                                salvandoEdicao = true
                                scope.launch {
                                    AuthApi.updateUser(
                                        u.id,
                                        role = if (isMaster) editRole else null,
                                        profileTypes = if (isMaster) ProfileTypes.normalize(editTags) else null,
                                        password = editSenha.trim().ifBlank { null },
                                        nome = editNome.trim(),
                                        acessos = if (isMaster) {
                                            Acessos.normalizar(editAcessos).let { lista ->
                                                if (editRole == "admin") lista.filter { it !in Acessos.acoes } else lista
                                            }
                                        } else null,
                                        ativosAbas = if (!isMaster) null else escopoAbas(editRole, editAcessos, editAbas),
                                        ativosCentros = if (!isMaster) null else escopoCentros(editRole, editAcessos, editLimitarCentros, editCentros)
                                    )
                                        .onSuccess {
                                            val msg = if (editSenha.isNotBlank()) {
                                                "Usuário ${it.nome ?: it.username} atualizado (senha alterada)."
                                            } else {
                                                "Usuário ${it.nome ?: it.username} atualizado."
                                            }
                                            avisoSalvo = msg
                                            onMessage(msg)
                                            editingId = null
                                            editSenha = ""
                                            editNome = ""
                                            recarregar()
                                        }
                                        .onFailure {
                                            erroEdicao = "Não salvou: ${it.message ?: "falha ao atualizar"}"
                                        }
                                    salvandoEdicao = false
                                }
                            },
                            enabled = !salvandoEdicao && (!isMaster || editTags.isNotEmpty()),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text(
                                when {
                                    salvandoEdicao -> "Salvando..."
                                    isMaster -> "Salvar alterações"
                                    else -> "Salvar"
                                }
                            )
                        }
                    }
                }
                }
            }
            }
            }
            PortalOutlinedButton(onClick = { recarregar() }, modifier = Modifier.fillMaxWidth()) {
                Text("Atualizar lista")
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun TagsEditor(
    opcoes: List<TagConfig>,
    rotuloDe: (String) -> String,
    tags: Set<String>,
    onChange: (Set<String>) -> Unit
) {
    Text("TAG * (função em campo, ao menos uma)", fontWeight = FontWeight.SemiBold)
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        opcoes.forEach { tag ->
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(
                    checked = tag.id in tags,
                    onCheckedChange = { marcado -> onChange(if (marcado) tags + tag.id else tags - tag.id) }
                )
                Text(rotuloDe(tag.id))
            }
        }
    }
}

/** [onChange] recebe os acessos e se foram ajustados à mão (false = padrão da TAG aplicado). */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun AcessosEditor(
    acessos: Set<String>,
    tags: Set<String>,
    adminRole: Boolean,
    onChange: (Set<String>, Boolean) -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text("Acessos", fontWeight = FontWeight.SemiBold, modifier = Modifier.weight(1f))
        TextButton(
            onClick = {
                val acoes = acessos.filter { it in Acessos.acoes }.toSet()
                onChange(Acessos.padraoDasTags(tags).toSet() + acoes, false)
            },
            enabled = tags.isNotEmpty()
        ) { Text("Aplicar padrão da TAG") }
    }
    @Composable
    fun Opcao(chave: String, rotulo: String) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Checkbox(
                checked = chave in acessos,
                onCheckedChange = { marcado -> onChange(if (marcado) acessos + chave else acessos - chave, true) }
            )
            Text(rotulo, style = MaterialTheme.typography.bodyMedium)
        }
    }
    Text("Formulários", style = MaterialTheme.typography.labelMedium)
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        Acessos.formularios.forEach { Opcao(it.id, it.rotulo) }
    }
    Text("Módulos", style = MaterialTheme.typography.labelMedium)
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        Acessos.modulos.forEach { chave ->
            Opcao(chave, Acessos.rotuloModulo(chave))
        }
    }
    if (!adminRole) {
        Text("Edição e exclusão", style = MaterialTheme.typography.labelMedium)
        Text(
            "Só para usuário comum. O administrador do módulo edita e exclui sem estas marcas.",
            style = MaterialTheme.typography.bodySmall
        )
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            Acessos.acoes.forEach { chave ->
                Opcao(chave, Acessos.rotuloAcao(chave))
            }
        }
    }
    if (acessos.isEmpty()) {
        Text(
            "Sem nenhum acesso marcado: o usuário entra, mas não vê formulários nem módulos.",
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.error
        )
    }
}

@OptIn(ExperimentalLayoutApi::class, ExperimentalMaterial3Api::class)
@Composable
private fun MatrizAcessos(
    users: List<AuthUserListItem>,
    centros: List<CentroCusto>,
    tags: List<TagConfig>,
    rotuloDe: (String) -> String,
    onMessage: (String) -> Unit,
    onSalvo: () -> Unit
) {
    val scope = rememberCoroutineScope()
    fun original(u: AuthUserListItem): Set<String> {
        val set = Acessos.normalizar(u.acessos).toMutableSet()
        if (u.role.equals("admin", true)) {
            Acessos.acoes.forEach { set.remove(it) }
            return set
        }
        val editaAba = u.ativosAbas.isNullOrBlank() || u.ativosAbas == "*" ||
            AtivosEscopo.modosDe(u.ativosAbas)["ATIVOS"] == "E"
        if (Acessos.ATIVOS in set && editaAba) set.add(Acessos.ATIVOS_EDITAR) else set.remove(Acessos.ATIVOS_EDITAR)
        return set
    }
    var rascunho by remember(users) { mutableStateOf(users.associate { it.id to original(it) }) }
    var escopos by remember(users) { mutableStateOf(users.associate { it.id to escopoDe(it) }) }
    var escopoAberto by remember { mutableStateOf<String?>(null) }
    var filtroTag by remember { mutableStateOf<String?>(null) }
    var busca by remember { mutableStateOf("") }
    var salvando by remember { mutableStateOf(false) }
    val alterados = users.filter { rascunho[it.id].orEmpty() != original(it) }
    val escopoAlterado = users.filter { escopos[it.id] != escopoDe(it) }
    val paraSalvar = (alterados + escopoAlterado).distinctBy { it.id }
    val visiveis = users.filter { u ->
        (filtroTag == null || u.profileTypes.any { it.equals(filtroTag, ignoreCase = true) }) &&
            (busca.isBlank() || u.username.contains(busca.trim(), true) || u.nome.orEmpty().contains(busca.trim(), true))
    }
    val colunas = Acessos.todas
    val colunasAcao = Acessos.acoes
    val larguraNome = 190.dp
    val larguraColuna = 78.dp

    fun usuarioDe(id: String) = users.firstOrNull { it.id == id }

    fun alternar(ids: Collection<String>, chave: String, marcar: Boolean) {
        val alvos = if (chave in Acessos.acoes) {
            ids.filter { usuarioDe(it)?.role.equals("admin", true).not() }
        } else ids
        rascunho = rascunho.toMutableMap().apply {
            alvos.forEach { id ->
                val atual = this[id].orEmpty().toMutableSet()
                if (marcar) atual.add(chave) else atual.remove(chave)
                if (!marcar && chave in Acessos.modulos) {
                    atual.remove("${chave}_EDITAR")
                    atual.remove("${chave}_EXCLUIR")
                }
                this[id] = atual
            }
        }
        if (chave == Acessos.ATIVOS_EDITAR) {
            val modo = if (marcar) "E" else "V"
            escopos = escopos.toMutableMap().apply {
                alvos.forEach { id ->
                    val u = usuarioDe(id) ?: return@forEach
                    val e = this[id] ?: escopoDe(u)
                    this[id] = e.copy(abas = AtivosEscopo.abas.associate { it.first to modo })
                }
            }
        }
    }

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao,
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            TituloSecao("Matriz de acessos")
            Text(
                "Marque o que cada usuário pode abrir. Administrador edita e exclui o conteúdo dos módulos que abre, sem coluna extra. " +
                    "Usuário comum usa Editar e Excluir. A linha \"Todos\" vale para o filtro. Nada muda até Salvar.",
                style = MaterialTheme.typography.bodySmall
            )
            AppOutlinedTextField(
                value = busca,
                onValueChange = { busca = it },
                label = { Text("Buscar usuário") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                FilterChip(
                    selected = filtroTag == null,
                    onClick = { filtroTag = null },
                    label = { Text("Todas as TAGs") }
                )
                tags.forEach { tag ->
                    FilterChip(
                        selected = filtroTag == tag.id,
                        onClick = { filtroTag = if (filtroTag == tag.id) null else tag.id },
                        label = { Text(rotuloDe(tag.id)) }
                    )
                }
            }
            val scrollMatriz = rememberScrollState()
            Column(Modifier.fillMaxWidth().horizontalScroll(scrollMatriz)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text("Usuário", fontWeight = FontWeight.SemiBold, modifier = Modifier.width(larguraNome))
                    colunas.forEach { chave ->
                        Text(
                            Acessos.rotuloCurto(chave),
                            style = MaterialTheme.typography.labelSmall,
                            textAlign = TextAlign.Center,
                            maxLines = 2,
                            modifier = Modifier.width(larguraColuna)
                        )
                    }
                    colunasAcao.forEach { chave ->
                        Text(
                            Acessos.rotuloCurto(chave),
                            style = MaterialTheme.typography.labelSmall,
                            textAlign = TextAlign.Center,
                            maxLines = 2,
                            modifier = Modifier.width(larguraColuna)
                        )
                    }
                }
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        "Todos (${visiveis.size})",
                        style = MaterialTheme.typography.labelMedium,
                        modifier = Modifier.width(larguraNome)
                    )
                    colunas.forEach { chave ->
                        val todos = visiveis.isNotEmpty() && visiveis.all { chave in rascunho[it.id].orEmpty() }
                        Box(Modifier.width(larguraColuna), contentAlignment = Alignment.Center) {
                            Checkbox(
                                checked = todos,
                                enabled = visiveis.isNotEmpty() && !salvando,
                                onCheckedChange = { marcar -> alternar(visiveis.map { it.id }, chave, marcar) }
                            )
                        }
                    }
                    colunasAcao.forEach { chave ->
                        val comuns = visiveis.filter { !it.role.equals("admin", true) }
                        val modulo = chave.substringBefore("_")
                        val elegiveis = comuns.filter { modulo in rascunho[it.id].orEmpty() }
                        val todos = elegiveis.isNotEmpty() && elegiveis.all { chave in rascunho[it.id].orEmpty() }
                        Box(Modifier.width(larguraColuna), contentAlignment = Alignment.Center) {
                            Checkbox(
                                checked = todos,
                                enabled = elegiveis.isNotEmpty() && !salvando,
                                onCheckedChange = { marcar -> alternar(elegiveis.map { it.id }, chave, marcar) }
                            )
                        }
                    }
                }
                HorizontalDivider(Modifier.width(larguraNome + larguraColuna * (colunas.size + colunasAcao.size)))
                visiveis.forEach { u ->
                    val atual = rascunho[u.id].orEmpty()
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Column(Modifier.width(larguraNome)) {
                            Text(
                                u.displayName + if (atual != original(u)) " *" else "",
                                style = MaterialTheme.typography.bodyMedium,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Text(
                                "${u.username} · ${ProfileTypes.normalize(u.profileTypes).joinToString(" + ") { rotuloDe(it) }.ifBlank { "—" }}",
                                style = MaterialTheme.typography.labelSmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                        colunas.forEach { chave ->
                            Box(Modifier.width(larguraColuna), contentAlignment = Alignment.Center) {
                                Checkbox(
                                    checked = chave in atual,
                                    enabled = !salvando,
                                    onCheckedChange = { marcar -> alternar(listOf(u.id), chave, marcar) }
                                )
                            }
                        }
                        colunasAcao.forEach { chave ->
                            val modulo = chave.substringBefore("_")
                            val admin = u.role.equals("admin", true)
                            Box(Modifier.width(larguraColuna), contentAlignment = Alignment.Center) {
                                if (admin) {
                                    Text("—", style = MaterialTheme.typography.labelSmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                                } else {
                                    Checkbox(
                                        checked = chave in atual,
                                        enabled = !salvando && modulo in atual,
                                        onCheckedChange = { marcar -> alternar(listOf(u.id), chave, marcar) }
                                    )
                                }
                            }
                        }
                    }
                }
            }
            HorizontalScrollbar(
                adapter = rememberScrollbarAdapter(scrollMatriz),
                modifier = Modifier.fillMaxWidth().padding(top = 4.dp),
                style = ScrollbarStyle(
                    minimalHeight = 16.dp,
                    thickness = 12.dp,
                    shape = RoundedCornerShape(6.dp),
                    hoverDurationMillis = 200,
                    unhoverColor = Color.White.copy(alpha = 0.55f),
                    hoverColor = Color.White
                )
            )
            if (visiveis.isEmpty()) {
                Text("Nenhum usuário neste filtro.", style = MaterialTheme.typography.bodySmall)
            }
            HorizontalDivider()
            Text("Ativos — abas e centros de custo", fontWeight = FontWeight.SemiBold)
            Text(
                "Para usuário comum com o módulo Ativos. Visualizar abre a aba; Editar permite cadastrar e alterar. " +
                    "A coluna Ed. Ativos marca todas as abas; aqui dá para liberar só algumas. " +
                    "Com a limitação ligada, ADM e TST só veem as obras marcadas.",
                style = MaterialTheme.typography.bodySmall
            )
            val comAtivos = visiveis.filter { !it.role.equals("admin", true) && Acessos.ATIVOS in rascunho[it.id].orEmpty() }
            if (comAtivos.isEmpty()) {
                Text("Nenhum usuário comum com Ativos neste filtro.", style = MaterialTheme.typography.bodySmall)
            }
            comAtivos.forEach { u ->
                val e = escopos[u.id] ?: escopoDe(u)
                TextButton(onClick = { escopoAberto = if (escopoAberto == u.id) null else u.id }) {
                    Text(
                        u.displayName +
                            (if (escopos[u.id] != escopoDe(u)) " *" else "") +
                            if (escopoAberto == u.id) " — fechar" else " — abas e centros"
                    )
                }
                if (escopoAberto == u.id) {
                    EscopoAtivosEditor(
                        abas = e.abas,
                        onAbas = { escopos = escopos + (u.id to e.copy(abas = it)) },
                        limitar = e.limitar,
                        onLimitar = { ligado ->
                            val base = if (ligado && e.centros.isEmpty()) {
                                centros.filter {
                                    it.admUsername.equals(u.username, true) || it.engenheiroUsername.equals(u.username, true)
                                }.map { it.id }.toSet()
                            } else e.centros
                            escopos = escopos + (u.id to e.copy(limitar = ligado, centros = base))
                        },
                        centrosSel = e.centros,
                        onCentros = { escopos = escopos + (u.id to e.copy(centros = it)) },
                        centros = centros
                    )
                }
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                PortalOutlinedButton(
                    onClick = {
                        rascunho = users.associate { it.id to original(it) }
                        escopos = users.associate { it.id to escopoDe(it) }
                    },
                    enabled = paraSalvar.isNotEmpty() && !salvando,
                    modifier = Modifier.weight(1f)
                ) { Text("Descartar") }
                PortalButton(
                    onClick = {
                        salvando = true
                        scope.launch {
                            var falhas = 0
                            paraSalvar.forEach { u ->
                                val acessos = Acessos.normalizar(rascunho[u.id].orEmpty()).let { lista ->
                                    if (u.role.equals("admin", true)) lista.filter { it !in Acessos.acoes } else lista
                                }
                                val e = escopos[u.id] ?: escopoDe(u)
                                AuthApi.updateUser(
                                    u.id,
                                    acessos = acessos,
                                    ativosAbas = escopoAbas(u.role, acessos.toSet(), e.abas),
                                    ativosCentros = escopoCentros(u.role, acessos.toSet(), e.limitar, e.centros)
                                ).onFailure { falhas++ }
                            }
                            salvando = false
                            onMessage(
                                if (falhas == 0) "Acessos salvos (${paraSalvar.size} usuário(s))."
                                else "Salvo com $falhas falha(s). Confira e tente de novo."
                            )
                            onSalvo()
                        }
                    },
                    enabled = paraSalvar.isNotEmpty() && !salvando,
                    modifier = Modifier.weight(1f)
                ) { Text(if (salvando) "Salvando..." else "Salvar (${paraSalvar.size})") }
            }
        }
    }
}

private data class EscopoUsuario(
    val abas: Map<String, String>,
    val limitar: Boolean,
    val centros: Set<String>
)

private fun escopoDe(u: AuthUserListItem) = EscopoUsuario(
    abas = AtivosEscopo.modosDe(u.ativosAbas),
    limitar = u.ativosCentros != null,
    centros = u.ativosCentros.orEmpty().split(',').map { it.trim() }.filter { it.isNotEmpty() }.toSet()
)

private fun escopoAbas(role: String, acessos: Set<String>, abas: Map<String, String>): String =
    if (role.equals("admin", true) || Acessos.ATIVOS !in acessos) "*" else AtivosEscopo.codificar(abas)

private fun escopoCentros(role: String, acessos: Set<String>, limitar: Boolean, centros: Set<String>): String =
    if (role.equals("admin", true) || Acessos.ATIVOS !in acessos || !limitar) "*" else centros.joinToString(",")

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun EscopoAtivosEditor(
    abas: Map<String, String>,
    onAbas: (Map<String, String>) -> Unit,
    limitar: Boolean,
    onLimitar: (Boolean) -> Unit,
    centrosSel: Set<String>,
    onCentros: (Set<String>) -> Unit,
    centros: List<CentroCusto>
) {
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        AtivosEscopo.abas.forEach { (chave, rotulo) ->
            val modo = abas[chave].orEmpty()
            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth()) {
                Text(rotulo, modifier = Modifier.weight(1f), style = MaterialTheme.typography.bodyMedium)
                Checkbox(
                    checked = modo == "V" || modo == "E",
                    onCheckedChange = { on -> onAbas(abas + (chave to if (on) "V" else "")) }
                )
                Text("Ver", style = MaterialTheme.typography.bodySmall)
                Checkbox(
                    checked = modo == "E",
                    onCheckedChange = { on -> onAbas(abas + (chave to if (on) "E" else "V")) }
                )
                Text("Editar", style = MaterialTheme.typography.bodySmall)
            }
        }
        Row(verticalAlignment = Alignment.CenterVertically) {
            Checkbox(checked = limitar, onCheckedChange = onLimitar)
            Text("Limitar aos centros de custo marcados", style = MaterialTheme.typography.bodyMedium)
        }
        if (limitar) {
            if (centros.isEmpty()) {
                Text("Não foi possível carregar as obras.", color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            } else {
                ListaCentrosSuspensa(centros, centrosSel, onCentros)
            }
        }
    }
}

@Composable
private fun ListaCentrosSuspensa(
    centros: List<CentroCusto>,
    selecionados: Set<String>,
    onCentros: (Set<String>) -> Unit
) {
    var aberto by remember { mutableStateOf(false) }
    var focado by remember { mutableStateOf(false) }
    var texto by remember { mutableStateOf("") }
    val marcados = centros.filter { it.id in selecionados }
    val resumo = when {
        marcados.isEmpty() -> ""
        marcados.size == 1 -> "${marcados[0].codigo} ${marcados[0].nome}"
        else -> "${marcados.size} centros marcados"
    }
    val termos = texto.trim().split(' ').filter { it.isNotBlank() }
    val lista = if (focado && termos.isNotEmpty()) {
        centros.filter { c -> termos.all { Ordenacao.contem("${c.codigo} ${c.nome}", it) } }
    } else {
        centros
    }
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val largura = maxWidth
        AppOutlinedTextField(
            value = if (focado) texto else resumo,
            onValueChange = {
                texto = it
                aberto = true
            },
            singleLine = true,
            label = { Text("Centros de custo") },
            placeholder = { Text(if (resumo.isBlank()) "Abrir lista" else resumo, maxLines = 1, overflow = TextOverflow.Ellipsis) },
            trailingIcon = {
                Icon(
                    if (aberto) Icons.Filled.KeyboardArrowUp else Icons.Filled.KeyboardArrowDown,
                    contentDescription = "Abrir lista",
                    modifier = Modifier.clip(RoundedCornerShape(50)).clickable { aberto = !aberto }
                )
            },
            modifier = Modifier.fillMaxWidth().onFocusChanged {
                if (it.isFocused && !focado) {
                    focado = true
                    texto = ""
                    aberto = true
                } else if (!it.isFocused && focado) {
                    focado = false
                    texto = ""
                }
            },
            colors = FormFieldDefaults.textFieldColors()
        )
        DropdownMenu(
            expanded = aberto,
            onDismissRequest = { aberto = false },
            properties = PopupProperties(focusable = false),
            modifier = Modifier.width(largura).heightIn(max = 320.dp)
        ) {
            if (lista.isEmpty()) {
                DropdownMenuItem(text = { Text("Nada encontrado", color = PortalCores.CinzaTexto) }, onClick = {}, enabled = false)
            }
            lista.forEach { c ->
                val marcado = c.id in selecionados
                DropdownMenuItem(
                    text = {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Checkbox(checked = marcado, onCheckedChange = null)
                            Text(
                                "${c.codigo} ${c.nome}" + if (!c.ativo) " (inativa)" else "",
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier.padding(start = 8.dp)
                            )
                        }
                    },
                    onClick = { onCentros(if (marcado) selecionados - c.id else selecionados + c.id) }
                )
            }
        }
    }
}

private fun iniciais(nome: String): String {
    val partes = nome.trim().split(Regex("[\\s._-]+")).filter { it.isNotBlank() }
    return when {
        partes.isEmpty() -> "?"
        partes.size == 1 -> partes[0].take(2).uppercase()
        else -> (partes.first().take(1) + partes.last().take(1)).uppercase()
    }
}
